import { lazyImport } from '../../Utils'

export const ExpandMoreIcon = lazyImport(() => import('@mui/icons-material/ExpandMore'))
export const NotificationsIcon = lazyImport(() => import('@mui/icons-material/Notifications'))
export const IosShareIcon = lazyImport(() => import('@mui/icons-material/IosShare'))
export const InputAdornment = lazyImport(() => import('@mui/material/InputAdornment'))
export const PollIcon = lazyImport(() => import('@mui/icons-material/Poll'))
export const LockIcon = lazyImport(() => import('@mui/icons-material/Lock'))
export const MailOutlineIcon = lazyImport(() => import('@mui/icons-material/MailOutline'))
export const AlternateEmailIcon = lazyImport(() => import('@mui/icons-material/AlternateEmail'))
export const CalendarRoundedIcon = lazyImport(() =>  import('@mui/icons-material/CalendarTodayRounded'))

// ARROWS //
export const KeyboardArrowRightIcon = lazyImport(() => import('@mui/icons-material/KeyboardArrowRight'))
export const KeyboardArrowDownIcon = lazyImport(() => import('@mui/icons-material/KeyboardArrowDown'))
export const KeyboardArrowUpIcon = lazyImport(() => import('@mui/icons-material/KeyboardArrowUp'))
// SOCIAL //
export const GoogleIcon = lazyImport(() => import('@mui/icons-material/Google'))

// CHART //
export const LineChartIcon = lazyImport(() => import('@mui/icons-material/ShowChart'))

// MAP //
export const MapRoundedIcon = lazyImport(() => import('@mui/icons-material/MapRounded'))
